import { useEffect, useState } from "react";
import './controles.css'
import carSvg from '../assets/car.svg';
import camionetaSvg from '../assets/camioneta.svg';
import casaSvg from '../assets/casa.svg'
import habitacionSvg from '../assets/habitacion.svg'
import genericLink from '../assets/genericLink.svg'
import CardCar from "./CardCar";
import inmersialSvg from "../assets/inmersial_white.svg"
import 'animate.css'


const initialStateDataSelected = {
  icono: "",
  titulo: "",
  url: "",
  imagen: "",
}

const ICONOS = {
  demo: inmersialSvg,
  auto: carSvg,
  camioneta: camionetaSvg,
  casa: casaSvg,
  habitacion: habitacionSvg,
}

//experiencias relacionadas: una fila de botones abajo a la izquierda y la tarjeta de la elegida
//arriba de la fila. Mientras el visitante charla con el asistente se ocultan, porque la barra del
//asistente ocupa el borde de abajo
const MenuEnlaces = ({ handleLinkButton, data=[], desplegarCard, enCharla }) => {
  const [showCardCar, setShowCardCar] = useState(false)
  const [selectedData, setSelectedData] = useState(data[0] || initialStateDataSelected)
  const [keyMemory, setKeyMemory] = useState(0)

  const handleOnClickIconButton = (index) => {
    setSelectedData(data[index])

    if(keyMemory === index) {
      setShowCardCar(prev => !prev)
    }

    if(keyMemory !== index && !showCardCar) {
      setShowCardCar(true)
    }

    setKeyMemory(index)
  }

  useEffect(() => {
    setShowCardCar(desplegarCard)
  }, [desplegarCard])

  if (!data.length) return null;

  return (
    <div
      id="menuFlotanteEnlaces"
      className={enCharla ? 'p360-en-charla' : ''}
      >
        <div className={`p360-tarjeta-enlace animate__animated ${showCardCar? 'animate__fadeInUp':'animate__fadeOutDown'}`}
          style={{ pointerEvents: showCardCar ? 'auto' : 'none' }}
        >
          <CardCar handleLinkButton={handleLinkButton}  data={selectedData}/>
        </div>
      <div className="p360-enlaces" role="toolbar" aria-label="Experiencias relacionadas">
        {data.map((item, index) => (
          <button
            key={index}
            type="button"
            className={`p360-btn p360-vidrio p360-enlace ${index === 0 ? 'fifth-step' : ''}`}
            title={item.titulo}
            aria-label={item.titulo || `Experiencia relacionada ${index + 1}`}
            aria-pressed={showCardCar && keyMemory === index}
            onClick={() => handleOnClickIconButton(index)}
          >
            <img src={ICONOS[item.icono] || genericLink} alt="" />
          </button>
        ))}
      </div>
    </div>
  );
};
export default MenuEnlaces;
